import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { ReactNode } from 'react';

interface PanelProps {
  heading: string;
  subText?: string;
  children: ReactNode;
  width?: number | string;
  height?: number | string;
}

const Panel: React.FC<PanelProps> = ({
  heading,
  subText = '',
  children,
  width = 350,
  height
}) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={1}
      sx={{
        width: width,
        height: height,
        overflow: 'hidden',
        border: '1px solid #e0e0e0',
        borderRadius: 1,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          bgcolor: 'primary.main',
          color: 'secondary.contrast',
          p: 1,
          borderTopLeftRadius: 'inherit',
          borderTopRightRadius: 'inherit',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            textAlign: 'center',
          }}
        >
          <Typography
            component="div"
            sx={{
              wordWrap: 'break-word',
              wordBreak: 'break-word',
              hyphens: 'auto',
              fontSize: {
                xs: '1.1rem',
                sm: '1.25rem',
                md: '1.5rem'
              }
            }}
          >
            
            {heading}{subText && <span style={{fontSize: "0.875rem" }}> {subText}</span>}
          </Typography>
        </Box>
      </Box>
      
      {/* Content */}
      {children}
    </Paper>
  );
};

export default Panel;